import Header from '@/components/CodeHeader';
import { Skeleton } from '@/components/Skeleton';
import { Text } from '@/design-system';
import { cn } from '@/design-system/utils/cn';

export const RunTreeSkeleton = ({
  isXsPanel,
  hasWaterfall,
  hideHeader = false,
}: {
  isXsPanel?: boolean;
  hasWaterfall?: boolean;
  hideHeader?: boolean;
}) => {
  const DEPTH_PADDING = 34;
  return (
    <div className="flex flex-col">
      {!hideHeader && (
        <Header
          sx={{
            mx: '16px',
            mt: '16px',
            userSelect: 'none',
            flexShrink: 0,
            flexDirection: 'column',
            height: 'auto',
          }}
          text={
            <div className="my-auto flex h-full items-center justify-between">
              <Text variant="h4">Trace</Text>
            </div>
          }
          textSx={{ mr: 'auto', my: 'auto', height: '32px', width: '100%' }}
          rightSx={{ mr: 'auto' }}
          right={
            <div className="flex gap-1">
              <Skeleton
                className={cn(
                  'my-0 h-[26px] w-[26px]',
                  isXsPanel && 'h-[26px] w-[54px]'
                )}
              />
              {hasWaterfall && !isXsPanel && (
                <Skeleton className={cn('my-0 h-[26px] w-[70px]')} />
              )}
              <Skeleton className={cn('my-0 h-[26px] w-[26px]')} />
              {!isXsPanel && <Skeleton className="my-0 h-[26px] w-[26px]" />}
            </div>
          }
        />
      )}
      {Array.from({ length: 4 }).map(() => (
        <div className="mx-4">
          <Skeleton className="mb-1 mt-0 h-[72px]" />
          {Array.from({ length: 2 }).map((_, index) => (
            <Skeleton
              key={index}
              className="my-1 h-[24px] w-auto"
              style={{
                marginLeft: DEPTH_PADDING,
              }}
            />
          ))}
          {Array.from({ length: 3 }).map((_, index) => (
            <Skeleton
              key={index}
              className="my-1 h-[24px]  w-auto"
              style={{
                marginLeft: DEPTH_PADDING * 2,
              }}
            />
          ))}

          <Skeleton
            className="my-1 h-[24px] w-auto"
            style={{
              marginLeft: DEPTH_PADDING,
            }}
          />
        </div>
      ))}
    </div>
  );
};
